import Raven from 'raven-js';
import { registerQuery, useQuery } from 'data-fetching-client';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file
import * as ContactsAPI from 'crm_data/contacts/api/ContactsAPI';
const fetchContacts = requestPayload => {
  return ContactsAPI.fetch(requestPayload).then(data => {
    return data;
  }).catch(error => {
    Raven.captureException(error, {
      fingerprint: ['ERROR_API_CONTACTS_FETCH_FAILED'],
      extra: {
        contactIds: JSON.stringify(requestPayload.toJS())
      }
    });
  });
};
export const ContactsQuery = registerQuery({
  fieldName: 'contacts',
  args: ['contactIds'],
  fetcher({
    contactIds
  }) {
    return fetchContacts(contactIds);
  }
});
export function useContactsQuery({
  contactIds,
  skip
}) {
  return useQuery(ContactsQuery, {
    variables: {
      contactIds
    },
    skip
  });
}